import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLatestAIStreamForCachingVariables = Types.Exact<{
  input: Types.AIInferenceStreamsMetadataInput;
}>;

export type GetLatestAIStreamForCaching = {
  aiInferenceStreamsMetadata: {
    edges: Array<{
      node: Pick<Types.AIInferenceStream, 'streamId' | 'createdAt' | 'alias' | 'parentStreamId'>;
    }>;
    pageInfo: Pick<
      Types.CursorBasedPaginationPageInfo,
      'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
    >;
  };
};

export const GetLatestAIStreamForCachingDocument = gql`
  query GetLatestAIStreamForCaching($input: AIInferenceStreamsMetadataInput!) {
    aiInferenceStreamsMetadata(input: $input) {
      edges {
        node {
          streamId
          createdAt
          alias
          parentStreamId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetLatestAIStreamForCaching__
 *
 * To run a query within a React component, call `useGetLatestAIStreamForCaching` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestAIStreamForCaching` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestAIStreamForCaching({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLatestAIStreamForCaching(
  baseOptions: Apollo.QueryHookOptions<
    GetLatestAIStreamForCaching,
    GetLatestAIStreamForCachingVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLatestAIStreamForCaching, GetLatestAIStreamForCachingVariables>(
    GetLatestAIStreamForCachingDocument,
    options,
  );
}
export function useGetLatestAIStreamForCachingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLatestAIStreamForCaching,
    GetLatestAIStreamForCachingVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLatestAIStreamForCaching, GetLatestAIStreamForCachingVariables>(
    GetLatestAIStreamForCachingDocument,
    options,
  );
}
export function useGetLatestAIStreamForCachingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLatestAIStreamForCaching,
    GetLatestAIStreamForCachingVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLatestAIStreamForCaching, GetLatestAIStreamForCachingVariables>(
    GetLatestAIStreamForCachingDocument,
    options,
  );
}
export type GetLatestAIStreamForCachingHookResult = ReturnType<
  typeof useGetLatestAIStreamForCaching
>;
export type GetLatestAIStreamForCachingLazyQueryHookResult = ReturnType<
  typeof useGetLatestAIStreamForCachingLazyQuery
>;
export type GetLatestAIStreamForCachingSuspenseQueryHookResult = ReturnType<
  typeof useGetLatestAIStreamForCachingSuspenseQuery
>;
export type GetLatestAIStreamForCachingQueryResult = Apollo.QueryResult<
  GetLatestAIStreamForCaching,
  GetLatestAIStreamForCachingVariables
>;
export function mockGetLatestAIStreamForCaching({
  data,
  variables,
  errors,
}: {
  data: GetLatestAIStreamForCaching;
  variables?: GetLatestAIStreamForCachingVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetLatestAIStreamForCachingDocument, variables },
    result: { data, errors },
  };
}
